import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Differentiators: React.FC = () => {
  const { t } = useTranslation();

  const itemKeys = ['communication', 'experience', 'preventive', 'human'];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section className="section bg-brand-sand">
      <div className="wrapper">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
          className="max-w-4xl mx-auto"
        >
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-heading text-brand-slate mb-12 text-center">
            {t('differentiators.title')}
          </motion.h2>

          <div className="space-y-6">
            {itemKeys.map((key, index) => (
              <motion.div key={index} variants={itemVariants} className="faq-item">
                <div className="flex items-start gap-4">
                  <ArrowRight className="w-5 h-5 text-brand-accent mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="faq-q text-lg mb-2">
                      {t(`differentiators.items.${key}.title`)}
                    </h3>
                    <p className="faq-a">
                      {t(`differentiators.items.${key}.text`)}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Differentiators;